import { CultureInfo } from '../culture-info.model';
import { CultureInfoUr } from './ur';

/**
 * @ignore
 */
export const CultureInfoUrArab: CultureInfo = {
  name: 'ur-Arab',
  displayName: 'اردو',
  iso3LanguageCode: 'urd',
  iso2LanguageCode: 'ur',
  ietfLanguageTag: 'ur-Arab',
  parent: CultureInfoUr
};
